import { render, staticRenderFns } from "./com-page-return.vue?vue&type=template&id=5bebb9c0&scoped=true&"
import script from "./com-page-return.vue?vue&type=script&lang=js&"
export * from "./com-page-return.vue?vue&type=script&lang=js&"
import style0 from "./com-page-return.vue?vue&type=style&index=0&id=5bebb9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebb9c0",
  null
  
)

export default component.exports